import {gql} from 'apollo-angular';


import { ASSET_FRAGMENT, CART_FRAGMENT, ERROR_RESULT_FRAGMENT } from '../../../common/graphql/fragments.graphql';

export const GET_PRODUCT_DETAIL = gql`
    query GetProductDetail($slug: String!) {
        product(slug: $slug) {
            id
            name
            description
            optionGroups {
                id
                code
                name
            }
            variants {
                id
                name
                options {
                    code
                    name
                    group {
                        id
                    }
                }
                price
                priceWithTax
                sku
                stockLevel
                featuredAsset {
                    ...Asset
                }
                assets {
                    ...Asset
                }
            }
            featuredAsset {
                ...Asset
            }
            assets {
                ...Asset
            }
            customFields {
                specifications
                warrantyText
                availabilityText
                deliveryText
                installationAvailable
                installationPrice
            }
            collections {
                id
                slug
                breadcrumbs {
                    id
                    name
                    slug
                }
            }
        }
    }
    ${ASSET_FRAGMENT}
`;

export const GET_DISCOUNTED_PRODUCTS = gql`
    query GetDiscountedProductsForDetail($take: Int) {
        discountedProducts(take: $take) {
            product {
                id
            }
            discountPercentage
            discountedVariants {
                variantId
                discountPercentage
            }
        }
    }
`;

export const ADD_TO_CART = gql`
    mutation AddToCart($variantId: ID!, $qty: Int!) {
        addItemToOrder(productVariantId: $variantId, quantity: $qty) {
            ...Cart
            ...ErrorResult
            ...on InsufficientStockError {
                order {
                    ...Cart
                }
            }
        }
    }
    ${CART_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;

export const ADD_TO_CART_WITH_INSTALLATION = gql`
    mutation AddToCartWithInstallation($variantId: ID!, $qty: Int!, $customFields: OrderLineCustomFieldsInput) {
        addItemToOrder(productVariantId: $variantId, quantity: $qty, customFields: $customFields) {
            ...Cart
            ...ErrorResult
            ...on InsufficientStockError {
                order {
                    ...Cart
                }
            }
        }
    }
    ${CART_FRAGMENT}
    ${ERROR_RESULT_FRAGMENT}
`;
